import * as React from 'react'
import * as constants from '../../../../../static/constants'
import styled from 'styled-components'
import MessageBalloon from './MessageBalloon'
import MessageLoader from './MessageLoader'
import I18n from 'core/i18n'
import Typography from 'components/atoms/_layouts/Typography'
import { IMessage, IUser } from 'static/interfaces'

interface IProps {
  messages: IMessage[]
  fetching: boolean
  user: IUser
  onUpdate?: () => void
}

const Messages: React.FC<IProps> = ({ messages, fetching, user, onUpdate }) => {
  const scrollerRef = React.useRef(null)
  // 重複メッセージを省く処理
  const parsedMessages = messages.filter((message, i, self) => {
    return self.findIndex(selfMessage => selfMessage.id === message.id) === i
  })
  return (
    <ConverSationMessages>
      <MessageLoader show={fetching} />
      <div ref={scrollerRef}>
        {parsedMessages.length > 0 ? (
          parsedMessages.map(message => (
            <MessageBalloon
              key={message.id}
              isGuide={user.guide}
              message={message}
              onUpdate={onUpdate}
            />
          ))
        ) : (
          <Typography type="body" size="lg" color="subtext">
            {I18n.t('generic.no_messages')}
          </Typography>
        )}
      </div>
    </ConverSationMessages>
  )
}
const ConverSationMessages = styled.div`
  flex: 1;
  background-color: ${constants.COLORS.cardBG};
  padding: 1rem;
`
export default Messages
